import { Component } from '@angular/core'
import { PipelineType, TsneParameters, UmapParameters } from '../../../shared/model/jobs'
import { HttpErrorResponse } from '@angular/common/http'
import { JobApiService } from '../../../shared/services/job-api.service'
import { ToasterService } from '../../../shared/services/toaster.service'
import { selectCaseMarkers } from '../../../state/case/case.selectors'
import { Store } from '@ngrx/store'
import { MarkerDimension } from '../../../state/case/case.state'
import { closeJobSelectionDialog } from '../../../shared/utils/job-selection-dialog-utils'

@Component({
    selector: 'app-clustering-selection',
    templateUrl: './clustering-selection.component.html',
    styleUrls: ['./clustering-selection.component.scss'],
})
export class ClusteringSelectionComponent {
    readonly PipelineTypeEnum = PipelineType

    selectedPipeline: PipelineType.tsneClustering | PipelineType.umapClustering | null = null

    readonly clusteringMarkers$ = this.store.select(selectCaseMarkers)

    private clusteringParams: TsneParameters | UmapParameters | null = null

    get clusteringParamsSet(): boolean {
        return this.clusteringParams !== null
    }

    constructor(
        private readonly jobApi: JobApiService,
        private readonly toaster: ToasterService,
        readonly store: Store
    ) {}

    confirmClusteringParameters(params: TsneParameters | UmapParameters): void {
        this.clusteringParams = params
    }

    abortMarkerSelection(): void {
        this.clusteringParams = null
    }

    selectMarkerLayers(eventData: { name: string; markers: MarkerDimension[] }): void {
        if (this.clusteringParams === null) return

        this.jobApi
            .startClusteringJob({
                ...this.clusteringParams,
                name: eventData.name,
                markers: eventData.markers.map(marker => marker.name),
            })
            .subscribe({
                next: () => closeJobSelectionDialog(),
                error: (err: HttpErrorResponse) => {
                    this.toaster.httpError(err, 'Error starting job')
                },
            })
    }
}
